<template>
    <div>
        <div v-if="information.can_show">
            <div class="mr-2 rounded-0 mb-0 text-center d-none d-md-block">
                <span v-if="information.diff_count > 0">
                    Faltam {{ information.diff_count }} alunos para atingir o limite do seu plano. Considere melhorar o seu plano!
                </span>
                <span v-if="information.diff_count === 0">
                    O Limite de Alunos foi atingido. Considere melhorar o seu plano!
                </span>
                <a v-if="information.endpoint_subscriptions" :href="information.endpoint_subscriptions" class="btn btn-sm ml-2 btn-primary">
                    Verificar assinatura
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['information'],
    data(){
        return {

        }
    },
    created(){
    },
    computed :{
        
    },
    methods: {
        
    }
}
</script>

<style>

</style>
